import { useEffect } from "react";
import { Userpilot } from "userpilot";

import { useStakeProvider, useTokenBalance, useWalletAccount } from "dapp-sdk";

import { fetchPageData } from "@utils/globalCommon";

import { PageProvider } from "@providers/PageProvider";

import XToken from "@container/pages/XToken";

import Sidebar from "@components/Sidebar";
import Header from "@components/Header";
import PageLayout from "@components/PageLayout";

interface PageProps {
  page: any;
  shouldDisplayBanner: boolean;
  isSafeMode: boolean;
}

const LiquidStakingPage = ({
  page,
  shouldDisplayBanner,
  isSafeMode,
}: PageProps) => {
  const { setMobileMenuVisible, firebaseEventsData } = useStakeProvider();
  const { address } = useWalletAccount();
  const { token } = useTokenBalance();

  useEffect(() => {
    if (address) {
      if ((window as any).userpilotSettings.userid !== address) {
        Userpilot.identify(address, {
          ...firebaseEventsData,
        });
      }
    } else {
      Userpilot.anonymous();
    }
  }, [address, token]);

  if (process.env.NEXT_PUBLIC_TOKEN === "ETH") {
    // TODO replace with 404 page
    return null;
  }

  return (
    <PageProvider page={page} isSafeMode={isSafeMode}>
      <PageLayout
        Sidebar={
          <Sidebar
            display={{ base: "none", xl: "block" }}
            minH={{
              base: "100vh",
              xl: shouldDisplayBanner ? "calc(100vh - 32px)" : "100vh",
            }}
          />
        }
        MobileSideBar={<Sidebar setMobileMenuVisible={setMobileMenuVisible} />}
        Header={<Header />}
      >
        <XToken />
      </PageLayout>
    </PageProvider>
  );
};

export async function getStaticProps() {
  const [resJson] = await Promise.all([
    fetchPageData(
      "liquid-staking-pages",
      Number(process.env.NEXT_PUBLIC_STRAPI_ID || 0)
    ),
  ]);
  const pageData = resJson.data?.attributes || null;
  const pageError = resJson.error || null;
  return {
    props: {
      page: {
        data: {
          ...pageData,
        },
        error: pageError,
      },
    },
  };
}

export default LiquidStakingPage;
